export default String.raw`
$(document).ready(function () {
    
    $('body').on('click', '.form__preview-js', function (e) {
        formPasswordPreview(e);
    });

    $('body').on('focus', '.input-value-js:not([type="checkbox"])', function (e) {
        formLabelAnimationFocus(e.currentTarget);
    });

    $('body').on('blur', '.input-value-js:not([type="checkbox"]):not([type="date"])', function (e) {
        formLabelAnimation(e.currentTarget);
    });

    $('.search-radio-js').click(function()  {
        if ($('.search-radio-js[value=searchAll]').is(":checked")) {
            $('.advanced-search-input-js').attr('name', 'searchAll');
        } else if ($('.search-radio-js[value=searchWild]').is(":checked")) {
            $('.advanced-search-input-js').attr('name', 'searchWild');
        } else if ($('.search-radio-js[value=searchAny]').is(":checked")) {
            $('.advanced-search-input-js').attr('name', 'searchAny');
        } else {
            $('.advanced-search-input-js').attr('name', 'name');
        }
    });

    $('.manufacturers-filters-js li').filter(':gt(7)').hide();
    $('.more-filter-manufacturer-search-js').filter(':lt(7)').hide();
    var showSearchFiltersButton = $('.more-filter-manufacturer-search-js');
    showSearchFiltersButton.click(function(){
        $('.manufacturers-filters-js li').filter(':gt(7)').toggle(500);
    });

    $('.brand-filters-js li').filter(':gt(7)').hide();
    $('.more-filter-brand-search-js').filter(':lt(7)').hide();
    var showSearchFiltersButton = $('.more-filter-brand-search-js');
    showSearchFiltersButton.click(function(){
        $('.brand-filters-js li').filter(':gt(7)').toggle(500);
    });

    js.delegate(document.body, 'click', '.toggle-dropdown-js', toggleDropdown);
});

$('input[name=unitNo]').attr({maxLength: 20});
$('input[name=streetNo]').attr({maxLength: 20});
$('input[name=phoneNo]').attr({maxLength: 20});

$('input[name=tin]').keyup(function () {
    this.value = this.value.replace(/[^0-9\.]/g,'');
});

$('body').on('click', '.hide-js', function(e) {
    e.stopPropagation();
});

js.delegate(document.body, 'click', '.hide-js', function() {
    this.classList.add('hidden-js');
    if(this.classList.contains('maps-container-js')){
        if(document.getElementsByClassName('collection-point-info-js').length > 0){
            document.getElementsByClassName('map-container-in-order-js')[0].classList.add('hidden-js');
            document.getElementsByClassName('collection-point-info-js')[0].classList.remove('hidden-js');
        }   
    }
    if(document.getElementsByClassName('sets-js').length > 0){
        const sets = js.parents(this, 'sets-js');
        if(sets && sets.length > 0){
            document.body.classList.remove('modal-opened');
        }
    }
});

$('body').on('click', '.open-next-element-js', function(e) {
    $(e.currentTarget).next().removeClass('hidden-js');
});

$('body').on('click', '.open-thresholds-js', function(e) {
  var name = $(e.currentTarget).data('name');
  var quantity = $(e.currentTarget).data('quantity');
  var price = $(e.currentTarget).data('price');
  var currency = $(e.currentTarget).data('currency');
  var thresholds = $(e.currentTarget).data('thresholds');
  var thresholdsArr = thresholds.split('||');
  var thresholdsHTML = '';
  for(var i=0; i<thresholdsArr.length - 1; i++){
    var thresholdArr = thresholdsArr[i].split('|');
    thresholdsHTML += '<div style="display: flex; justify-content: space-between;">'+
                                    '<div>'+thresholdArr[0]+'</div>'+
                                    '<div>'+thresholdArr[1]+' '+currency+'</div>'+
                                '</div>'
  }
  $('body').append('<div class="message-popup-background delete-container-js container-to-delete-js" style="width: 100vw; height: 100vh;">'+
                        '<div class="message-popup" style="max-width: 300px; top: 50%; bottom: auto; transform: translateY(-50%); margin: auto;">'+
                            '<h3>'+name+'</h3>'+
                            '<div style="display: flex; justify-content: space-between;">'+
                                '<strong>'+quantity+'</strong>'+
                                '<strong>'+price+'</strong>'+
                            '</div>'+
                            thresholdsHTML+
                        '</div>'+
                    '</div>');
});

$('body').on('click', '.delete-container-js', function(e) {
    e.stopPropagation();
    app.delete(e);
});

js.delegate(document.body, 'click', '.hide-container-js', function(e) {
    if(this.classList.contains('container-to-hide-js')){
        if (e.target !== this){
            return;
        }
        this.classList.add('hidden-js');
    } else {
        const containerToHide = js.parents(this, 'container-to-hide-js');
        if(containerToHide){
            containerToHide.classList.add('hidden-js');
        }
    }
    if(document.getElementsByClassName('sets-js').length > 0){
        const sets = js.parents(this, 'sets-js');
        if(sets && sets.length > 0){
            document.body.classList.remove('modal-opened');
        }
    }
});

js.delegate(document.body, 'click', '.closing-modal-mobile-js', (e) => {
    const containerToDelete = e.target.closest('.container-to-delete-js');

    if (!containerToDelete) {
        return;
    }

    if (!e.target.classList.contains('error-js')) {
        containerToDelete.remove();
    }
});

$('body').on('click', 'a', function(e) {
    e.stopPropagation();
});

function toggleCategoryInfo() {
    const page = document.querySelector('.pagination-js [name="quantity"]').value;
    if(page != 1 && page != undefined){
        document.getElementsByClassName('category-info-js')[0].classList.add('hidden-js');
        if(window.innerWidth <= 1279) {
            document.getElementsByClassName('products-page-js')[0].classList.add('no-category');
        }
    } else {
        document.getElementsByClassName('category-info-js')[0].classList.remove('hidden-js');
        if(window.innerWidth <= 1279) {
            document.getElementsByClassName('products-page-js')[0].classList.remove('no-category');
        }
    }
};

if(document.getElementsByClassName('category-info-js').length > 0){
    toggleCategoryInfo();
    $(document).ajaxSuccess(function() {
        toggleCategoryInfo();
    });
}

$('body').on('click', '.pagination-js button', function() {
    app.scrollToElement('', 'body');
});

$('body').on('change', '.pagination-js input', function() {
    app.scrollToElement('', 'body');
});

$('body').on('click', '.pager-js button', function() {
    app.scrollToElement('', 'body');
});

$('body').on('change', '.pager-js input', function() {
    app.scrollToElement('', 'body');
});

$('body').on('change', '[name="notifyDate"]:not(.prevent-js)', function(e) {
    if($(e.currentTarget).val() != ''){
        $(e.currentTarget).removeClass('validation-error');
        $('.after-adding-to-wishlist-popup-js .validation-required-js').addClass('hidden-js');
    }
});

function routerSetPage(page) {
    var path = 'pageId='+page;
    var url = window.location.href;
    var origin = window.location.origin;
    var pathname = window.location.pathname;
    var query = window.location.search;
    if(query != ''){
        if(query.indexOf(path) == -1){
            if(query.indexOf('pageId=') != -1){
                if(query.indexOf("&") != -1){
                    var queries = query.split('&');
                    var size = queries.length;
                    query = '';
                    for(var i=0; i<size; i++){
                        if(queries[i].indexOf('pageId=') == -1){
                            if(query == ''){
                                query += queries[i];
                            } else {
                                query += '&'+queries[i];
                            }

                        }
                    }
                    url = origin + pathname + query + '&' + path;
                } else {
                    url = origin + pathname + '?' + path;
                }
            } else {
                url += '&' + path;
            }
        }
    } else {
        url += '?' + path;
    }
    history['pushState']({}, '', url);
};

/**
 * Wraps an asynchronous function with spinner visibility control.
 * 
 * This higher-order function ensures that a spinner element is shown during 
 * the execution of the wrapped function and hidden once the function completes.
 * 
 * @param {Function} fn - The asynchronous function to be wrapped.
 * @returns {Function} A new function that wraps the original function with spinner visibility control.
 */
function withSpinner(fn) {
    return async function (...args) {
        const spinner = document.querySelector('.during-ajax-modal-js');

        try {
            if (spinner) {
                spinner.classList.remove('hidden-js');
            }

            return await fn(...args);
        } finally {
            if (spinner) {
                spinner.classList.add('hidden-js');
            }
        }
    }
}

const addToWishList = async (wishlistId, products) => {
    const normalizedProducts = Array.isArray(products) ? products : [products];
    const parameters = normalizedProducts
        .filter(product => {
            if (!product.productId) {
                throw new Error('Product ID is required');
            }
            return product.productId;
        })
        .filter(product => {
            if (!product.quantity || product.quantity <= 0 || product.quantity >= 99999) {
                throw new Error('Invalid quantity value.');
            }
            return product.quantity > 0 && product.quantity < 99999;
        })
        .map(product => ({
            ...(wishlistId ? { wisId: wishlistId } : {}),
            productId: wishlistId ? product.productId : product.supplyId || product.productId,
            quantity: product.quantity,
            ...(wishlistId ? product.supplyId && { supplyId: product.supplyId } : {}),
            ...(wishlistId && product.unitId ? { unitId: product.unitId } : {}),
            ...(wishlistId && product.attributeEditable ? { attributeEditable: product.attributeEditable } : {}),
            ...(wishlistId && product.attributeId ? { attributeId: product.attributeId } : {}),
            ...(wishlistId ? {} : (product.note ? { note: product.note } : {}))
        }));

    const data = {
        __csrf: __CSRF,
        __action: wishlistId ? 'Wishlist/ProductAdd' : 'Product/WishlistAdd',
        __parameters: JSON.stringify(parameters)
    };

    try {
        const response = await $.post(null, data);
        const products = response?.action?.Products;
        const notAddedProducts = response?.action.Results;

        if (products?.length > 0) {
            window.dispatchEvent(new CustomEvent('wishlist:added', { 
                detail: { 
                    products: products,
                    failure: notAddedProducts?.length > 0 ? true : false
                }
            }));
        }

        const isSingleProductNotAdded =  (!response?.action.Result && response?.action?.Object);
        if (isSingleProductNotAdded || notAddedProducts?.length > 0) {
            window.dispatchEvent(new CustomEvent('validation:failure', {
                detail: {
                    title: __translations.NotAddedToWishList,
                    results: response.action.Results || [response.action]
                }
            }));
            return;
        }

        if(response?.action.Code != 0) {
            app.temporaryPopupMessage(undefined, response.action.Message, response.action.Type);
            return;
        }
    } catch (error) {
        console.error("Error adding to wishlist:", error);
    }
};

const WishListUI = (() => {
    'use strict';
    let eventTargetRef = null;

    $('body').on('click', '.add-to-wishlist-js', async (e) => {
        let wishListId = Number($('.add-wishlist-popup-js input[name="wishlistId"]:checked').val());

        // Get form that stores all necessary data (data/inputs as fallback values)
        // If eventTargetRef contains serial-adding-to-wishlist-js then we choose different data serialization strategy
        let products = [];
        const button = eventTargetRef ? $(eventTargetRef) : $(e.target);
        const $lookbook = $('.lookbook');

        let productsJSON = "";
        if ($lookbook.length > 0) {
            const $loobookItems = $lookbook.find('.lookbook__item');
            
            for (const lookbookItem of $loobookItems) {
                if ($(lookbookItem).data("clicked") === "true") {
                    productsJSON = $(lookbookItem).data("lookbook-products");
                    $(lookbookItem).data("clicked", "false");
                    break;
                }
            }
        }

        if (button.hasClass('serial-adding-to-wishlist-js')) {
            const forms = $('.add-to-cart-js');

            forms.each(function() {
                const quantityInput = $(this).find('[name="quantity"]');
                if (!quantityInput || quantityInput.length === 0) {
                    return;
                }

                const quantity = Number(quantityInput.val().replace(__decSep, '.'));
                const productId = $(this).find('[name="productId"]').val();
                const unitId = Number($(this).find('[name="unitId"]').val()) || null;

                if (!productId || !quantity || quantity <= 0 || quantity >= 99999) {
                    return;
                }

                products.push({
                    productId: productId,
                    quantity: quantity,
                    unitId: unitId
                });
            });

        // For lookbook
        } else if (productsJSON != "") {
            for (const product of productsJSON) {
                products.push({
                    productId: product.id,
                    quantity: product.quantity === "" ? 1 : product.quantity,
                    unitId: product.unitId ? product.unitId : null
                });
            }
        } else {
            const form = button.closest('.add-to-cart-js');
            const productId = form.closest('[data-product-id]').data('product-id') || form.find('input[name="productId"]').val();

            const baseProduct = {
                productId: productId
            };

            const childs = window.childs || [];

            if (childs.length > 0) {
                childs.forEach(child => {
                    const quantity = Number(child.quantity);

                    if (!quantity || quantity <= 0 || quantity >= 99999) {
                        return;
                    }

                    const supplyId = child.supply || null;
                    const attributeEditable = child.attributesEditable || [];
                    const attributeId = child.attributesPolyvalent || [];
                    const unitId = Number(child.unit) || null;

                    const childProduct = {
                        ...baseProduct,
                        ...(supplyId ? {supplyId: supplyId} : {}),
                        quantity: quantity,
                        ...(unitId ? { unitId: unitId } : {}),
                        ...(attributeEditable.length ? {attributeEditable: attributeEditable} : {}),
                        ...(attributeId.length ? {attributeId: attributeId} : {})
                    };
                    products.push(childProduct);
                });
            }
            else {
                const quantityInput = form.find('input[name="quantity"]');
                if (!quantityInput || quantityInput.length === 0) {
                    console.error("Quantity input element not found.");
                    return;
                }

                const quantity = Number(quantityInput.val().replace(__decSep, '.'));
                const unitId = Number(form.find('[name="unitId"]').val());
                if (!quantity || quantity <= 0 || quantity >= 99999) {
                    return;
                }
                const attributeEditable = form.find('[name="attributeEditable"]').map(function () {
                    return $(this).val();
                }).get();
                const attributeId = form.find('[name="attributePolyvalent"]').map(function () {
                    return $(this).val();
                }).get();
                
                if (quantity && quantity > 0 && quantity < 99999) {
                    const simpleProduct = {
                        ...baseProduct,
                        quantity: quantity,
                        ...(attributeEditable ? {attributeEditable: attributeEditable} : {}),
                        ...(attributeId ? {attributeId: attributeId} : {}),
                        ...(unitId ? { unitId: unitId } : null),
                    };
                    products.push(simpleProduct);
                }
            }
        }

        if (products.length === 0) {
            app.temporaryPopupMessage(undefined, __translations.fillQuantityOfChoosenProducts, 'info');
            return;
        }
    
        // Adding new wishlist radio wishlistId (value=-1)
        if (wishListId === -1) {
            const newWishListName = $('.add-wishlist-popup-js input[name="wishlistName"]').val();
            
            if (newWishListName) {
                const data = {
                    __csrf: __CSRF,
                    __action: "Wishlist/Add",
                    name: newWishListName
                };
    
                try {
                    const response = await $.post(null, data);
                    wishListId = response?.action?.Object;
                } catch (error) {
                    console.error("Error adding new wishlist: ", error);
                }
            }
        }
    
        await addToWishList(wishListId, products);
    });

    // Multiple Wishlists choice B2B only
    const popup = document.querySelector('.popup-js');

    if (!popup || !__isB2B) {
        return;
    }

    $('body').on('click', '.show-add-to-wishlist-popup-js', async (e) => {
        try {
            const response = await $.get(__CPLink, {
                __template: 'partials/wishlist/add-to-wishlist-popup.html',
                __collection: 'customer-profile.WishLists'
            });
            const template = response?.template;
    
            if (!template) {
                return;
            }

            popup.innerHTML = template;
            const dialog = popup.querySelector('dialog');
            dialog?.showModal();
            eventTargetRef = e.target;
        } catch (error) {
            console.error(error);
        }
    });

    $('body').on('click', '.add-new-wishlist-js', (e) => {
        $(e.currentTarget).prop('disabled', true);
        $('.add-new-wishlist-target-js').removeClass('hidden-js');
        $('.add-new-wishlist-target-js input[type="radio"]').prop('checked', true);
        $('.add-new-wishlist-target-js input[type="text"]').focus();
    });

    $('body').on('input change focus', '.add-wishlist-popup-js input[type="text"], .add-wishlist-popup-js input[type="radio"]', (e) => {
        const $radioButton = $('.add-wishlist-popup-js input[type="radio"]:checked');
        const $wishlistButton = $('.add-wishlist-popup-js .add-to-wishlist-js');
        const $associatedInput = $radioButton.closest('li').find('input[type="text"]');
        
        if ($radioButton.length > 0 && $associatedInput.length > 0) {
            if ($associatedInput.val().trim() !== '' && !$associatedInput.hasClass('validation-error-js')) {
                $wishlistButton.prop('disabled', false);
            } else {
                $wishlistButton.prop('disabled', true);
            }
        } else {
            $wishlistButton.prop('disabled', false);
        }
    });
})();

const serialAddFromWishlist = async () => {
    try {
        const requestData = {
            __csrf: __CSRF,
            __collection: 'customer-profile'
        };

        const result = await $.get(__CPLink, requestData);
        const wishlist = result?.collection?.WishList || [];

        if (wishlist.length === 0) {
            console.log("No items in the wishlist.");
            return;
        }

        const productsToAdd = wishlist.map(item => ({
            productId: item.Product?.Id,
            ...(item.Quantity && { quantity: item.Quantity }),
            ...(item.UnitId && { unitId: item.UnitId }),
            ...(item.AttributeId && item.AttributeId.length > 0 && { attributeId: item.AttributeId }),
            ...(item.AttributeEditable && item.AttributeEditable.length > 0 && { attributeEditable: item.AttributeEditable }),
            ...(item.SupplyId && { supplyId: item.SupplyId })
        }));

        const postData = {
            __csrf: __CSRF,
            __action: 'Cart/Add',
            __parameters: JSON.stringify(productsToAdd),
            __template: 'partials/common/header/client-area.html',
            __collection: 'customer.Cart.Id'
        };

        const response = await $.post('', postData);
        const products = response?.action?.Products;
        const notAddedProducts = response?.action?.Results?.filter(item => item.Code !== 0) || [];

        if (response?.action.Code != 0) {
            app.temporaryPopupMessage(undefined, response.action.Message, response.action.Type);
            return;
        }

        window.dispatchEvent(new CustomEvent('cart:added', {
            detail: {
                products: products,
                strategy: notAddedProducts?.length > 0 ? "2" : __aatc
            }
        }));

        const isSingleProductNotAdded =  (!response?.action.Result && response?.action?.Object);
        if (isSingleProductNotAdded || notAddedProducts?.length > 0) {
            window.dispatchEvent(new CustomEvent('validation:failure', {
                detail: {
                    results: notAddedProducts || [response.action]
                }
            }));
        }

        $('.client-area-js').html(response.template);
        changeHeaderCart();
        window.app.setCookie('lastCartId', response.collection);
    } catch (error) {
        console.error("Error serial adding from wishlist: ", error);
    }
};

$('body').on('click', '.serial-adding-from-wishlist-js', withSpinner(async () => {
    await serialAddFromWishlist();
}));

$('body').on('click', '.add-new-wishlist-js', function(e) {
    if (app.validationBeforePost(e, $('.add-new-wishlist-popup-js')) != 'error') {
        const newWishlistName = $('.add-new-wishlist-popup-js input').val();
        const data = {
            __csrf: __CSRF,
            __template: 'static-elements/wishlist/wishlist.html',
            __action: 'Wishlist/Add',
            name: newWishlistName
        }
        $.post(null, data, function(res) {
            if(res.action.Result) {
                $('.add-new-wishlist-popup-js').addClass('hidden-js');
                $('.add-new-wishlist-popup-js input').val('');
                $('.wishlist-global-container-js').replaceWith(res.template);
            }
            app.selects($('.wishlist-global-container-js'));
        });
    }
});

function showLoader(e, containerClass) {
    var container = $(e.currentTarget).parents(containerClass);
    var url = $(e.currentTarget).data('url');
    container.children().addClass('hidden-js');
    container.find('.loading-cart-in-progress-js').removeClass('hidden-js');
    container.find('.loader-js').removeClass('hidden-js');
    if(containerClass == '.change-inquiry-js' || window.location.search.includes('inquiry=true')){
        if(containerClass == '.change-inquiry-js'){
            var id = $(e.currentTarget).data('inquiry-id');
        } else {
            var id = $(e.currentTarget).data('cart-id');
        }
        $.post('', {__action: 'Cart/Change', id: id, __csrf: __CSRF}, function() {
            window.location.href = url;
        });
    } else if($(e.currentTarget).data('url') != null){
        window.location.href = url;
    }
};

$('body').on('click', '.load-cart-js', function(e) {
    showLoader(e, '.change-cart-js');
});

$('body').on('click', '.open-carts-list-popup-js', function(e) {
    e.preventDefault();
    $('.small-cart-change-popup-js [data-id="-1"]').trigger('click');
});

$('body').on('click', '.load-inquiry-js', function(e) {
    showLoader(e, '.change-inquiry-js');
});

function signIn(e) {
    return new Promise(function(resolve, reject) {
        $.get('', {__collection: 'customer.UserId32|customer.Cart.Id'}, function (result) {
            window.app.setCookie('lastCartId', result.collection['customer.Cart.Id']);
            var userId = result.collection['customer.UserId32'];
            app.dataLayerPush('login', userId);
            if(typeof gtag != 'undefined'){
                gtag("event", "login", {
                    method: userId
                });
            }
            resolve();
        });
        showLoader(e, '.login-form-js');
    });
};

$('body').on('click', '.login-js', function(e) {
    showLoader(e, '.login-form-js');
    app.post(e, signIn, e);
});

function setBreadcrumbsProductNameMaxWidth() {
    const ul = document.getElementsByClassName('breadcrumbs-js')[0];
    const ulWidth = ul.innerWidth;
    const products = ul.querySelectorAll('li');
    const product = products[products.length - 1];
    const siblings = js.getSiblings(product);
    let siblingsWidth = 0;
    for(let sibling of siblings){
        siblingsWidth += sibling.innerWidth + 5;
    }
    const max = ulWidth - siblingsWidth;
    product.style.maxWidth = max;
};

if(document.getElementsByClassName('product-presentation-js').length > 0){
    setBreadcrumbsProductNameMaxWidth();
    $(window).resize(function() {
        setBreadcrumbsProductNameMaxWidth();
    });
}

window.onpopstate = function(e) {
    var query = document.location.search;
    if(query.indexOf('&') != -1){
        var queries = query.split('&');
        var size = queries.length;
        for(var i =0; i<size; i++){
            if(queries[i].indexOf('pageId=') != -1){
                var id = queries[i].split('=')[1];
            }
        }
    } else {
        var id = query.split('=')[1];
    }

    var input = $('.routing-js [name=quantity]');
    var baseURL = input.data('base-url');
    input.val(id);
    input.attr('data-url', baseURL + id);
    input.addClass('replace-template-js');

    var url = input.data('url');
    var template = input.parents('[data-template]').data('template');
    var container = input.parents('[data-container]').data('container');

    $.get(url, {__template: template}, function (result) {
        $(container).html(result.template);
    });

    input.removeClass('replace-template-js');
};

$(window).on('load', function() {
    if ($('.product-presentation-js').index() > -1) {
        let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isSafari) {
            $('.gallery-container-js').find('img').addClass('safari-img');
        }
    }  
});



$('body').on('click', '.routing-replace-template-js', function(e) {
    app.replaceTemplate(e, undefined, routingAfterReplaceTemplate);

    const paginationObserved = document.querySelector('.product-list');
    
    const paginationObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'childList' || mutation.type === 'characterData') {
                $($('.product-item-js a')[0]).focus();
            }
        }
    )});

    const paginationObserverConfig = {
        childList: true,
        subtree: true,
        characterData: true
    };

    paginationObserver.observe(paginationObserved, paginationObserverConfig);
});

$('body').on('keydown', '[type=number]', function (e) {
    if ((e.keyCode != 48 && e.keyCode != 49 && e.keyCode != 50 && e.keyCode != 51 && e.keyCode != 52 && e.keyCode != 53 && e.keyCode != 54 && e.keyCode != 55 && e.keyCode != 56 && e.keyCode != 57 && e.keyCode != 96 && e.keyCode != 97 && e.keyCode != 98 && e.keyCode != 99 && e.keyCode != 100 && e.keyCode != 101 && e.keyCode != 102 && e.keyCode != 103 && e.keyCode != 104 && e.keyCode != 105 && e.keyCode != 46 && e.keyCode != 8 && e.keyCode != 13 && e.keyCode != 37 && e.keyCode != 38 && e.keyCode != 39 && e.keyCode != 40 && e.keyCode != 188 && e.keyCode != 190 && e.keyCode != 110) || ((__decSep == ',' && (e.keyCode == 190 || e.keyCode == 110)) || (__decSep == '.' && e.keyCode == 188))) {
        e.preventDefault();
    }
});

function routingAfterReplaceTemplate(){
    window.productList.changeValidationConditions();
    var page = Number($('.change-quantity__active').text());
    routerSetPage(page);
}

$('body').on('input', 'textarea', function(e) {
    const $textarea = $(e.currentTarget);
    const counter = $textarea.parent().find('.characters-counter-js');
    const maxQuantity = Number($textarea.attr('maxlength'));
    const text = $textarea.val();

    let byteLength = 0;
    let properText = '';
    
    for (let char of text) {
        const currentByteLength = new TextEncoder().encode(char).length;
        if (byteLength + currentByteLength > maxQuantity) break;
        properText += char;
        byteLength += currentByteLength;
    }
    
    if (byteLength > 0) {
        counter.text(byteLength + ' / ' + maxQuantity);
        counter.removeClass('hidden-js');
        if (byteLength >= maxQuantity) {
            counter.addClass('error__length');
        } else {
            counter.removeClass('error__length');
        }
    } else {
        counter.addClass('hidden-js');
    }
    
    if (properText !== text) {
        $textarea.val(properText);
        counter.text(maxQuantity + ' / ' + maxQuantity);
    }
});

function deleteFormTitle(){
    $('.title-js').remove();
    $('.during-ajax-modal-js').addClass('hidden-js');
}

$('body').on('click', '.post-and-delete-title-js', function(e) {
    $('.during-ajax-modal-js').removeClass('hidden-js');
    app.post(e, deleteFormTitle);
    if(typeof gtag != 'undefined' && $(e.currentTarget).data('value')){
        gtag("event", "generate_lead", {
            currency: __currCode,
            value: $(e.currentTarget).data('value')
        });
    }
});

$('body').on('click', '.load-product-presentation-form-js', function(e) {
    $('.container-to-delete-js').remove();
    app.replaceTemplate(e);
    const container = document.querySelector(e.currentTarget.dataset.container);
    const config = { childList: true, subtree: true };
    const callback = () => {
        container.querySelector('dialog')?.showModal();
        observer.disconnect();
    };
    const observer = new MutationObserver(callback);
    observer.observe(container, config);
});

$('body').click(function(){ 
    if($('.share-product-js').hasClass('active-js')){
        $('.share-product-dropdown-js').parent().find('.recommend-product-js').remove();
        $('.share-product-dropdown-js .container-to-delete-js').remove();
        $('.share-product-js').removeClass('active-js');
    }
});

/* Share product from product-details page */
$('body').on('click', '.share-product-js', function(e) {
    e.stopPropagation();
    $('.share-product-dropdown-js').parent().find('.recommend-product-js').remove();
    $('.container-to-delete-js').remove();
    if(!$('.share-product-js').hasClass('active-js')){
        app.replaceTemplate(e);
    }
    $('.share-product-js').toggleClass('active-js');
});


$('body').on('click', '.copy-link-js', (e) => {
    if (!navigator?.clipboard) {
        console.warn('Clipboard API not supported');
        return;
    }

    const textToCopy = window.location.href;
    if (!textToCopy) {
        console.warn('No text available to copy.');
        return;
    }

    const message = $(e.currentTarget).data('info');
    if (!message) {
        console.warn('No message provided for the popup.');
        return;
    }

    navigator.clipboard.writeText(textToCopy)
        .then(() => app.temporaryPopupMessage(undefined, message, 'msg'))
        .catch(err => console.error('Failed to copy text: ', err));
});

$('body').on('click', '.copy-js', async (e) => {
    if (!navigator?.clipboard) {
        console.warn('Clipboard API not supported');
        return;
    }

    const closestElement = e.target.closest('[data-text]');
    const textToCopy = closestElement ? closestElement.dataset.text : null;
    if (!textToCopy) {
        console.warn('No text available to copy.');
        return;
    }

    navigator.clipboard.writeText(textToCopy)
        .then(() => {
            app.temporaryPopupMessage(undefined, __translations.AfterCopyMessage, 'msg');
        })
        .catch(err => {
            console.error('Failed to copy text: ', err);
        });
});

$('body').on('click', '.mobile-share-button-js', async (e) => {
    if (!navigator.share) {
        console.warn('Your browser does not support the Web Share API.');
        return;
    }

    const productName = $(e.currentTarget).data('product-name');
    const productLink = $(e.currentTarget).data('link');

    try {
        await navigator.share({ title: productName, text: productName, url: productLink });
    } catch (error) {
        console.error('Error sharing:', error);
    }
});

$('body').on('click', '.share-recommend-js', function(e) {
    e.stopPropagation();
  	$('.share-product-js').removeClass('active-js');
    $('.share-product-dropdown-js').parent().append('<div class="recommend-product-js"></div>');
});

$('body').on('click', '.share-product-dropdown-js a', function(e) {
    e.stopPropagation();
  	$('.share-product-dropdown-js').parent().find('.recommend-product-js').remove();
    $('.share-product-dropdown-js .container-to-delete-js').remove();
    $('.share-product-js').removeClass('active-js');
});




function showPrices() {
    const pricesViews = document.querySelectorAll('.prices-view-js');
	for(let pricesView of pricesViews){
		pricesView.classList.remove('hidden-js');
	}
    const attributesViews = document.querySelectorAll('.attributes-view-js');
    for(let attributesView of attributesViews){
		attributesView.classList.add('hidden-js');
	}
	document.getElementsByClassName('show-attributes-js')[0].classList.remove('active-js');
	document.getElementsByClassName('show-prices-js')[0].classList.add('active-js');
    if(document.getElementsByClassName('arrow-js').length > 0){
		document.getElementsByClassName('arrow-js')[0].classList.add('hidden-js');
	}
	document.getElementsByClassName('cart-product-container-js')[0].classList.remove('attributes-opened');
};

function showAttributes() {
    const pricesViews = document.querySelectorAll('.prices-view-js');
	for(let pricesView of pricesViews){
		pricesView.classList.add('hidden-js');
	}
	const page = document.getElementsByClassName('show-attributes-js')[0].dataset.page;
	if(window.innerWidth <= 1279) {
		var attributesViews = document.querySelectorAll('.attributes-view-js');
	} else {
        var attributesViews = document.querySelectorAll('.attributes-view-js.page'+page+'-js');
	}
    for(let attributesView of attributesViews){
		attributesView.classList.remove('hidden-js');
	}
	document.getElementsByClassName('show-prices-js')[0].classList.remove('active-js');
	document.getElementsByClassName('show-attributes-js')[0].classList.add('active-js');
    if(document.getElementsByClassName('arrow-js').length > 0){
		document.getElementsByClassName('arrow-js')[0].classList.remove('hidden-js');
    }
	document.getElementsByClassName('cart-product-container-js')[0].classList.add('attributes-opened');
};

js.delegate(document.body, 'click', '.show-prices-js:not(.active-js)', showPrices);

js.delegate(document.body, 'click', '.show-attributes-js:not(.active-js)', showAttributes);

function editElementAttributes(e) {
    var form = $(e.currentTarget).parents('.form-js');
    var inputs = form.find('[name="attribute"]');
    var isValid = true;
    inputs.each(function(){
        if($(this).prop('required') && $(this).val() == ''){
            isValid = false;
        }
    });
    if(isValid){
        var data = form.find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();
        data.push({ name: '__csrf', value: __CSRF });
        if($('.customer-profile-content-js').index() != -1){
            data.push({ name: '__template', value: 'partials/customer-profile/orders/order-details.html' });
            if($('[data-current]').index() != -1){
                var page = $('[data-current]').data('current');
                if(window.editOrder.orderRequestUrl.indexOf('orderDetPageId='+page) === -1){
                    if(window.editOrder.orderRequestUrl.indexOf('orderDetPageId') !== -1){
                        window.editOrder.orderRequestUrl = window.editOrder.orderRequestUrl.substring(0, window.editOrder.orderRequestUrl.indexOf('&orderDetPageId')) + '&orderDetPageId=' + page;
                    } else {
                        window.editOrder.orderRequestUrl = window.editOrder.orderRequestUrl + '&orderDetPageId=' + page;
                    }
                }
            }
            $.post(window.editOrder.orderRequestUrl, data, function(res){
                $('.customer-profile-content-js').html(res.template);
                $('.show-attributes-js').trigger('click');
            });
        } else {
            $.post('', data);
        }
    }
};

$('body').on('change', '.position-attributes-set-form-js [name="attribute"]', function(e) {
    editElementAttributes(e)
});

function updateButtonClass() {
    if (window.innerWidth < 768) {
        $('.product-label .primary-action-button')
            .removeClass('primary-action-button')
            .addClass('secondary-action-button');
    } else {
        $('.product-label .secondary-action-button')
            .removeClass('secondary-action-button')
            .addClass('primary-action-button');
    }
}

updateButtonClass();

$(window).on('resize', function () {
    updateButtonClass();
});

function changeAttributesPage() {
    const parent = document.getElementsByClassName('show-attributes-js')[0];
    const currentPage = Number(parent.dataset.page);
    const lastPage = Number(parent.dataset.pages);
    if(this.classList.contains('next-attributes-page-js')){
        var newPage = currentPage + 1;
        document.getElementsByClassName('prev-attributes-page-js')[0].classList.remove('hidden-js');
        if(newPage == lastPage){
            this.classList.add('hidden-js');
        }
    } else {
        var newPage = currentPage - 1;
        document.getElementsByClassName('next-attributes-page-js')[0].classList.remove('hidden-js');
        if(newPage == 1){
            this.classList.add('hidden-js');
        }
    }
    parent.dataset.page = newPage;
    const elements = document.getElementsByClassName('attributes-view-js');
    for(let element of elements){
        element.classList.add('hidden-js');
    }
    document.getElementsByClassName('attributes-view-js.page'+newPage+'-js')[0].classList.remove('hidden-js');
};

$('body').on('click', '.change-attributes-page-js', function(e) {
    e.stopPropagation();
});

js.delegate(document.body, 'click', '.change-attributes-page-js', changeAttributesPage);

if($('.categories-and-filters-js').index() != -1 && $(window).height() > 1279){
    $(window).scroll(function(){
        var scrollPosition = $(this).scrollTop();
        var windowHeight = $(this).height();
        var menu = $('.categories-and-filters-js');
        var menuPosition = menu.offset().top;
        var menuHeight = windowHeight - 45 - menuPosition + scrollPosition;
        menu.css('height', menuHeight);
    });
}

function validateAfterReplace(e){
    var ct = $(e.currentTarget).find('option:selected');
    var template = ct.parents('[data-template]').data('template');
    var container = ct.parents('[data-container]').data('container');
    var include = '"'+ct.data('include')+'"';

    if (!$(e.currentTarget).is('select')) {
        ct = $(e.currentTarget);
        template = ct.data('template');
        container = ct.data('container');
        include = '"'+ct.data('include')+'"';
    }

    $.get('', {__template: template, __include: include}, function (result) {
        $(container).html(result.template);
        if(container != '.add-da-js'){
            if(container != '.register-js') {
                app.validation(e, $('body').find(container).find('[name=countryCode]'));
                app.validationBeforePost(e, $('body').find(container).parents('.form-js'));
            }
            if (container == '.customer-data-address-js') {
                var form = $('body').find(container);
                if (form.length > 0) {
                    var vateuSelect = form.find('[name="vateu"]');
                    vateuSelect = vateuSelect[vateuSelect.length - 1];
                    var vateuSelectOptions = $(vateuSelect).find('option');
                    if (vateuSelectOptions.length == 2) {
                        $(vateuSelect).val($(vateuSelectOptions[1]).val());
                    }
                }
            }
            if (container == '.customer-data-address-js') {
                if($('[name=countryCode]').val() != 'PL'){
                    $('.download-GUS-data-js').addClass('hidden-js');
                    if ((euCountriesISOWithoutPL.includes($('[name=countryCode]').val()) && $('[name=vateu]').val() != '') 
                        || ($('[name=countryCode]').val() == 'GB' && $('[name=vateu]').val() == 'XI')) {
                        $('.download-VIES-data-js').removeClass('hidden-js');
                    } else {
                        $('.download-VIES-data-js').addClass('hidden-js');
                    }
                } else {
                    $('.download-GUS-data-js').removeClass('hidden-js');
                    $('.download-VIES-data-js').addClass('hidden-js');
                }
            }
        }
        app.formLabelAnimationOnLoadPage();
        app.getDataFromExternalBase(e);
    });
}

$('body').on('change', '.validate-after-replace-js', function(e) {
    validateAfterReplace(e);
});

function rollTableProducts(trigger, type) {
    if(document.getElementsByClassName('products-table-js').length > 0){
        var table = document.getElementsByClassName('products-table-js')[0];
    } else if(document.getElementsByClassName('order-products-list-js').length > 0) {
        var table = document.getElementsByClassName('order-products-list-js')[0];
    } else if(document.getElementsByClassName('sor-products-list-js').length > 0) {
        var table = document.getElementsByClassName('sor-products-list-js')[0];
    } else if(document.getElementsByClassName('wm-products-list-js').length > 0) {
        var table = document.getElementsByClassName('wm-products-list-js')[0];
    } else {
        var table = document.getElementsByClassName('invoice-products-list-js')[0];
    }
    if(type == 'out'){
        var products = table.querySelectorAll('.expand-data-js:not(.expanded-js)');
    } else {
        var products = table.querySelectorAll('.expand-data-js.expanded-js');
    }

     const timeOut = setTimeout(() => {
        for(let product of products){
            product.classList.add('affected-all-js');
            product.click();
        }
        clearTimeout(timeOut);
    });
};

js.delegate(document.body, 'click', '.roll-out-js', function() {
    rollTableProducts(this, 'out');
});

js.delegate(document.body, 'keydown', '.roll-out-js', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
        rollTableProducts(this, 'out');
    }
});

js.delegate(document.body, 'click', '.roll-up-js', function() {
    rollTableProducts(this, 'up');
});

js.delegate(document.body, 'keydown', '.roll-up-js', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
        rollTableProducts(this, 'up');
    }
});

$('body').on('click', '.accept-login-consents-js', function (e) {
    var url = $(e.currentTarget).data('url');
    app.post(e, app.replace, url);
});

function toggleChannels() {
    if(this.tagName == 'span'){
        const container = js.parents(this, 'tos-container-js');
        const channels = container.getElementsByClassName('channel-js');
        for(let channel of channels){
            channel.classList.toggle('disabled-channel-js');
        }
        const inputs = container.querySelectorAll('[name=channelKey]:not([type=hidden])');
        for(let input of inputs){
            if(input.disabled){
                input.disabled = false;
            } else {
                input.disabled = true;
                input.checked = false;
            }
        }
    }
};

js.delegate(document.body, 'click', '.tos-js', toggleChannels);

js.delegate(document.body, 'click', '.change-button-siblings-js', (e) => {
    const currentButton = e.target;
    const parentContainer = currentButton.closest('.parent-js');
    if (parentContainer) {
        const siblingButtons = parentContainer.querySelectorAll('.change-button-siblings-js'); 
        for (let button of siblingButtons) {
            button.classList.toggle('hidden-js');
        }
    }
});

function toggleDropdown() {
    const parent = this.dataset.container;
    const container = document.querySelector(parent + ' .dropdowns-js');
    container.classList.toggle('hidden-js');
}

function changeCart() {
    const form = js.parents(this, 'form-js');
    const parent = js.parents(this, 'add-to-cart-form-container-js');
    if(parent){
        parent.getElementsByClassName('choose-cart-form-js')[0].classList.remove('hidden-js');
    }
    if(form){
        form.getElementsByClassName('add-to-cart-button-js')[0].classList.add('hidden-js');
        form.getElementsByClassName('change-cart-label-js')[0].classList.remove('hidden-js');
    }
}

js.delegate(document.body, 'click', '.change-cart-js', changeCart);

$('body').on('click', '.change-inquiry-js', function (e) {
    e.stopPropagation();
});

function colorActiveAttributePolyvalent(e, parent, element) {
    const $container = $(e.currentTarget).closest(parent);
    const $elements = $container.find(element);

    $elements.removeClass('active-js');
    $(e.currentTarget).closest(element).addClass('active-js');
}

$('body').on('click', '[data-many-attributes-id]', (e) => colorActiveAttributePolyvalent(e, '.attributes-js', "[data-many-attributes-id]"));
$('body').on('change click', '.attr-graphical-variants-js .graphical-variant-js input[type="radio"][name="attributeId"]', function(e) {
    colorActiveAttributePolyvalent(e, '.attr-graphical-variants-js', ".graphical-variant-js");
});

Number.prototype.format = function(n, x, s, c) {
    let re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
        num = this.toFixed(Math.max(0, ~~n));

    return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
};

Number.prototype.toPrice = function (d) {
    const decimalPlaces = d || __decimalPlacesPrice || 2;
    return this.format(decimalPlaces, 3, ' ', __decSep);
}

$('body').on('click', '.load-deeper-lvl-js', function (e) {
    e.stopPropagation();
    const $element = $(e.currentTarget);
    
    if ($('.customer-profile-js').length > 0 && typeof app.customerProfileRouting !== 'undefined') {
        app.customerProfileRouting.navigateToDetails(e, function(evt) {
            if ($element.hasClass('open-order-details-js')) {
                $('body').trigger('openProfileOrder', {
                    id: $element.data('id') || null,
                    orderRequestUrl: $element.data('url')
                });
            }
            app.getFirstFocusableElement('.customer-profile-content-js');
        });
    } else {
        app.replaceTemplate(e, undefined, function (evt) {
            if ($element.hasClass('open-order-details-js')) {
                $('body').trigger('openProfileOrder', {
                    id: $element.data('id') || null,
                    orderRequestUrl: $element.data('url')
                });
            }
            app.getFirstFocusableElement('.customer-profile-content-js');
        }, e);
    }
});

function loadFirstLvl(){
    window.erpPageNo = undefined;
    window.erpOrderId = undefined;
    window.erpInvoiceId = undefined;
    window.erpSORId = undefined;
    window.erpWMId = undefined;
}

$('body').on('click', '.load-first-lvl-js', function (e) {
    if ($('.customer-profile-js').length > 0 && typeof app.customerProfileRouting !== 'undefined') {
        app.customerProfileRouting.navigateToList(e, function() {
            app.getFirstFocusableElement('.customer-profile-content-js');
        });
    } else {
        app.replaceTemplate(e, undefined, () => {
            loadFirstLvl();
            app.getFirstFocusableElement('.customer-profile-content-js');
        });
    }
});

$('body').on('keydown keyup', '[max]', function(e){
    var val = Number($(this).val());
    var max = Number($(this).attr('max'));
    if (val > max
        && e.keyCode !== 46 // keycode for delete
        && e.keyCode !== 8 // keycode for backspace
    ) {
        e.preventDefault();
        $(this).val(max);
    }
});

function adjustCategoryMenuToUrlBar(){
    //Somehow innerHeight is > than height() when url bar is hidden and when it is visible innerHeight == height()
    if(window.innerHeight == $(window).height()){
        document.getElementsByClassName('categories-and-filters-js')[0].classList.add('url-bar-visible');
    } else {
        document.getElementsByClassName('categories-and-filters-js')[0].classList.remove('url-bar-visible');
    }
}

if(document.getElementsByClassName('categories-and-filters-js').length > 0 && window.innerWidth <= 1279){
    adjustCategoryMenuToUrlBar();
    window.addEventListener('resize',function(){
        adjustCategoryMenuToUrlBar();
    });
}

function addAttachementInComplaint() {
    window.attachementsInComplaint = [];
    const form = js.parents(this, 'form-js');
    const filesArr = form.getElementsByClassName('add-attachement-in-complaint-js');
    for (let file of filesArr) {
        if (file.files.length > 0) {
            const maxSize = file.dataset.fileSize;
            
            if (file.files[0].size > maxSize) {
                const message = file.dataset.sizeExceeded;
                const popup = '<div class="message-popup-background errors-js cancel-js container-to-delete-js">' +
                        '<div class="popup-container message-popup-on-background-js">' +
                            '<div class="data-form__header">' +
                                __translations.AttachementsNotAdded +
                                '<button class="close-button cancel-js" aria-label="'+__translations.Close+'">' +
                                    '<svg width="24" height="24" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#times-'+__iconStyle+'"></use></svg>' +
                                '</button>' +
                            '</div>' +
                            '<div class="info">' +
                                '<strong>'+file.files[0].name + '</strong>: <div>' + message + '</div' +
                            '</div>' +
                        '</div>' +
                    '</div>';
                document.body.innerHTML += popup;
                const popupMessage = $('.errors-js');
                const closeFunction = () => {
                    popupMessage.find('.cancel-js').click();
                }
                app.setLockFocus(popupMessage, () => closeFunction(), $(document.activeElement));
                file.value = '';
            } else {
                window.attachementsInComplaint.push(file.files[0]);

                if (file.classList.contains('contact-file-js') || file.classList.contains('add-attachement-in-complaint-js')) {
                    if (file.classList.contains('contact-file-js')) {
                        file.parentNode.nextElementSibling.classList.remove('hidden-js');
                    }

                    const extension = file.files[0].name.split('.').pop().toLowerCase();
                    let iconPath;

                    switch (extension) {
                        case "jfif":
                        case "jpe":
                        case "jpeg":
                        case "jpg":
                            iconPath = 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#file-image-' + __iconStyle;
                            break;
                        case "csv":
                            iconPath = 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#file-csv-' + __iconStyle;
                            break;
                        case "doc":
                        case "docx":
                        case "odt":
                            iconPath = 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#file-word-' + __iconStyle;
                            break;
                        case "xls":
                        case "xlsx":
                        case "ods":
                            iconPath = 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#file-spreadsheet-' + __iconStyle;
                            break;
                        case "zip":
                        case "rar":
                        case "7zip":
                            iconPath = 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#file-archive-' + __iconStyle;
                            break;
                        case "pdf":
                            iconPath = 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#file-pdf-' + __iconStyle;
                            break;
                        case "txt":
                            iconPath = 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#file-alt-' + __iconStyle;
                            break;
                        default:
                            iconPath = 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#file-' + __iconStyle;
                            break;
                    }

                    const parent = file.parentNode.parentNode;
                    const iconSvg = parent.querySelector('.icon-js use');

                    if (iconSvg) {
                        iconSvg.setAttribute('xlink:href', iconPath);
                    }

                    parent.querySelector('.input-text-js').textContent = file.files[0].name;
                    
                    if (file.classList.contains('contact-file-js')) {
                        parent.querySelector('.clear-contact-file-input-js').classList.remove('hidden-js');
                    }
                    parent.classList.remove('hidden-js');
                } else {
                    file.classList.remove('hidden-js');
                }
            }
        }
    }
    app.formLabelAnimationOnLoadPage();
};

js.delegate(document.body, 'change', '.add-attachement-in-complaint-js', addAttachementInComplaint);

js.delegate(document.body, 'click', '.add-attachement-in-complaint-label-js', function() {
    const attachementList = $(this).parent().find('.file-container.hidden-js');
    if(attachementList.length > 0) {
        $(attachementList[0]).find('label').click();
    }
});

$('body').on("change", 'input[type="checkbox"]', function() {
    const label = $(this).closest('label[role="checkbox"]');
    if ($(this).is(':checked')) {
        label.attr('aria-checked', 'true');
    } else {
        label.attr('aria-checked', 'false');
    }
});

function formPasswordPreview(e) {
    const icon = e.currentTarget;
    const svgIcon = icon.querySelector('svg use');
    const input = $(icon).siblings('input');
    if (input.attr('type') == 'password') {
        input.attr('type', 'text');
        $(icon).addClass('visible');
        svgIcon.setAttribute('xlink:href', 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#eye-slash-'+__iconStyle);
    } else {
        input.attr('type', 'password');
        $(icon).removeClass('visible');
        svgIcon.setAttribute('xlink:href', 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#eye-'+__iconStyle);
    }
};

function formLabelAnimationFocus(element) {
    var label = element.closest('.form__input-wrapper').querySelector('.input-info-js');
    if (label && element.value === '' && !element.readOnly) {
        label.style.top = '1px';
        label.style.fontSize = '12px';
        label.style.lineHeight = '16px';
        label.style.padding = '0 4px';
        label.style.zIndex = '1';
    }
};
function formLabelAnimation(element) {
    var label = element.closest('.form__input-wrapper').querySelector('.input-info-js');
    if (label && element.value === '') {
        label.style.top = '20px';
        label.style.fontSize = '14px';
        label.style.lineHeight = '20px';
    } else if (label) {
        label.style.top = '1px';
        label.style.fontSize = '12px';
        label.style.lineHeight = '16px';
        label.style.padding = '0 4px';
        label.style.zIndex = '1';
    }
};

function updateLabelAfterFill(form) {
    form.find('.input-value-js').each(function () {
        var input = $(this);
        var label = input.closest('.form__input-wrapper').find('.input-info-js');
        var type = input.attr('type');
        var value = input.val();

        if (value !== '') {
            input.parent().find('.validation-required-js').addClass('hidden-js');
            input.parent().find('.form__input-info').removeClass('validation-error');
            
            if (type == 'checkbox') {
                $(this).next('label').removeClass('validation-error-js');
            }

            if (label.length) {
                label.css({
                    'top': '1px',
                    'font-size': '12px',
                    'line-height': '16px',
                    'padding': '0 4px',
                    'z-index': '1'
                });
            }
        } else {
            if (label.length) {
                label.css({
                    'top': '',
                    'font-size': '',
                    'line-height': ''
                });
            }
        }
    });
};

function pausePlugin({ swiper, extendParams, on }) {
	extendParams({
		pause: {
			enabled: false,
			el: null,
			pauseAriaLabel: 'Pause slideshow',
			playAriaLabel: 'Play slideshow',
		},
	});

	let pauseButton;
	let isPaused = false;

	function togglePausePlay() {
		if (!swiper.autoplay.running && !isPaused) return;

		if (isPaused) {
            swiper.autoplay.start();
            isPaused = false;
            pauseButton.classList.remove('is-paused');
            pauseButton.setAttribute('aria-label', swiper.params.pause.pauseAriaLabel);
            pauseButton.setAttribute('aria-pressed', 'false');
            
            const svgUse = pauseButton.querySelector('svg use');
            if (svgUse && svgUse.getAttribute('href')) {
                const href = svgUse.getAttribute('href');
                svgUse.setAttribute('href', href.replace('play-circle', 'pause-circle'));
            }
        } else {
            swiper.autoplay.stop();
            isPaused = true;
            pauseButton.classList.add('is-paused');
            pauseButton.setAttribute('aria-label', swiper.params.pause.playAriaLabel);
            pauseButton.setAttribute('aria-pressed', 'true');
            
            const svgUse = pauseButton.querySelector('svg use');
            if (svgUse && svgUse.getAttribute('href')) {
                const href = svgUse.getAttribute('href');
                svgUse.setAttribute('href', href.replace('pause-circle', 'play-circle'));
            }
        }
	}

	function createPauseButton() {
		const pauseParams = swiper.params.pause;
		if (!pauseParams.enabled) return;

		if (pauseParams.el) {
			if (typeof pauseParams.el === 'string') {
				try {
					pauseButton = document.querySelector(pauseParams.el);
				} catch (error) {
					console.error('Invalid CSS selector provided for pauseParams.el:', pauseParams.el);
					return;
				}

				if (!pauseButton) {
					console.error('Element not found for selector:', pauseParams.el);
					return;
				}
			} else {
				pauseButton = pauseParams.el;
			}
		} else if (swiper.params.createElements) {
			pauseButton = document.createElement('div');
			pauseButton.className = 'swiper-button-pause';
			swiper.el.appendChild(pauseButton);
		}

		if (pauseButton) {
            pauseButton.setAttribute('aria-label', pauseParams.pauseAriaLabel);
            pauseButton.setAttribute('aria-pressed', 'false');
            pauseButton.setAttribute('role', 'button');
            pauseButton.setAttribute('tabindex', '0');
            
            pauseButton.addEventListener('click', togglePausePlay);
            pauseButton.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
                    event.preventDefault();
                    togglePausePlay();
                }
            });
        }
	}

    function updatePauseButtonVisibility() {
        if (!pauseButton) return;
        
        const hasEnoughSlides = swiper.slides.length > swiper.params.slidesPerView;
        const autoplayEnabled = swiper.params.autoplay && swiper.params.autoplay.enabled !== false;
        
        if (hasEnoughSlides && autoplayEnabled) {
            pauseButton.style.display = 'flex';
            
            if (swiper.autoplay.running) {
                pauseButton.classList.remove('is-paused');
                pauseButton.setAttribute('aria-label', swiper.params.pause.pauseAriaLabel);
                pauseButton.setAttribute('aria-pressed', 'false');
                
                const svgUse = pauseButton.querySelector('svg use');
                if (svgUse && svgUse.getAttribute('href')) {
                    const href = svgUse.getAttribute('href');
                    if (href.includes('play-circle')) {
                        svgUse.setAttribute('href', href.replace('play-circle', 'pause-circle'));
                    }
                }
            } else {
                pauseButton.classList.add('is-paused');
                pauseButton.setAttribute('aria-label', swiper.params.pause.playAriaLabel);
                pauseButton.setAttribute('aria-pressed', 'true');
                
                const svgUse = pauseButton.querySelector('svg use');
                if (svgUse && svgUse.getAttribute('href')) {
                    const href = svgUse.getAttribute('href');
                    if (href.includes('pause-circle')) {
                        svgUse.setAttribute('href', href.replace('pause-circle', 'play-circle'));
                    }
                }
            }
        } else {
            pauseButton.style.display = 'none';
        }
    }

	on('init', () => {
		if (!swiper.params.pause.enabled) return;
		createPauseButton();
		updatePauseButtonVisibility();
	});

	on('autoplayStart', () => {
		if (!pauseButton) return;
		isPaused = false;
		pauseButton.classList.remove('is-paused');
		updatePauseButtonVisibility();
	});

	on('autoplayStop', () => {
		updatePauseButtonVisibility();
	});

	on('slidesLengthChange', () => {
        updatePauseButtonVisibility();
    });
    
    on('slidesGridLengthChange', () => {
        updatePauseButtonVisibility();
    });
    
    on('breakpoint', () => {
        updatePauseButtonVisibility();
    });

	on('destroy', () => {
        if (pauseButton) {
            pauseButton.removeEventListener('click', togglePausePlay);
            pauseButton.removeEventListener('keydown', handleKeydown);
            pauseButton.remove();
        }
    });
}

Swiper.use([pausePlugin]);
`